<template>
  <div class="my-4 mx-md-5 mx-lg-10 mx-xl-15 pa-2 pt-md-0 px-md-4 mt-10 maxw-1750">
      <v-card tile>
         <v-card-title
            class="pa-2 py-2"
            style="background-color: #1565C0;"
         >
            <span class="white--text"> {{$t('views.cache.title')}} </span>
         </v-card-title>
         <v-card-text class="subtitle py-2">
            <v-row
               justify="space-between"
            >
               <v-btn
                  v-for="(item,i) in itemsCache"
                  :key="`action-cache-${i}`"
                  class="ma-2 col-md-2"
                  :loading="loading"
                  :disabled="loading"
                  color="grey lighten-2"
                  @click.stop="submit(item.function)"
               >
                  {{item.title}}
               </v-btn>
            </v-row>
         </v-card-text>
      </v-card>
      <v-snackbar
          v-model="message.active"
          bottom
          :color="message.color"
        >
         <span class="text-center"> {{ message.text }} </span>
      </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      client: null,
      message: {
        active: false,
        color: null,
        text: null,
      },
    };
  },
  computed: {
    itemsCache() {
      return this.$getConst('cache.items');
    },
  },
  methods: {
    async submit(method) {
      this.loading = true;
      try {
        const response = await this.client.send(method);
        const { message } = response.unique();
        if (message === 'success') {
          this.message = {
            active: true,
            color: 'green lighten-1',
            text: this.$t('views.cache.response.success'),
          };
        }
        if (message === 'not found') {
          this.message = {
            active: true,
            color: 'light-blue',
            text: this.$t('views.cache.response.notFound'),
          };
        }
      } catch (ex) {
        console.log('Error in cache', ex);
        this.message = {
          active: true,
          color: 'red lighten-1',
          text: this.$t('views.cache.response.error'),
        };
        this.loading = false;
      }

      this.loading = false;
    },
  },
  created() {
    this.client = this.$api.getClient('cache');
  },
};
</script>
